




























import { Vue, Component, Prop } from 'vue-property-decorator';
import DOMPurify from 'dompurify';

@Component({})
export default class TextArea extends Vue {
  @Prop(String)
  value!: string;
  @Prop(String)
  readonlyHtml!: string;
  @Prop(Number)
  maxLength!: number;
  @Prop(Boolean)
  disabled!: boolean;
  @Prop(String)
  placeholder!: string;
  @Prop(Boolean)
  noResize!: boolean;
  @Prop(Number)
  twoColumnBreakpoint!: number;
  @Prop(Boolean)
  fullWidth!: boolean;
  @Prop({ type: String, default: '250px' })
  minHeight!: string;
  @Prop(Boolean) hasError!: boolean;

  get sanitizedHtml(): string {
    return !!this.readonlyHtml
      ? DOMPurify.sanitize(this.readonlyHtml, { ALLOWED_TAGS: ['a'], ALLOWED_ATTR: ['href', 'target'] })
      : this.value;
  }

  get currentLength() {
    return this.value?.length ?? 0;
  }

  get twoColumns() {
    return !!(this.value?.length > this.twoColumnBreakpoint);
  }

  valueChanged(event: any) {
    this.$emit('change', event.target.value);
  }
}
